import React from 'react';

type CheckoutContainerProps = {
  children: React.ReactNode;
  customClass?: string;
}

export const CheckoutContainer = ({ children, customClass }: CheckoutContainerProps): React.JSX.Element => (
  <div className="row" data-test-id="checkout-container">
    <div className={`col-12 ${customClass ? customClass : ''}`}>
      {children}
    </div>
  </div>
);

export default CheckoutContainer;
